import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import { PwaLaunchRedirect } from "./components/PwaLaunchRedirect";
import "./index.css";

const container = document.getElementById("root");
if (!container) throw new Error("Root element not found");

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <PwaLaunchRedirect />
      <App />
    </BrowserRouter>
  </StrictMode>,
);

/*
 * Service worker — cache-first for assets, network-first for navigation.
 * Lets the app load offline and qualify for the "install app" prompt.
 *
 * Registered immediately, NOT on `window.load`. Chrome judges installability
 * when the page finishes loading, and a worker that starts registering at that
 * point has not finished — so the check fails and no install offer is made.
 * Waiting for `load` meant the app was one visit behind on installability.
 *
 * A failure here is not user-visible; the app still works without it.
 */
if ("serviceWorker" in navigator) {
  if (import.meta.env.DEV) {
    // Vite source URLs are stable: a cache-first worker can pin an old page
    // even after the development server has compiled the latest changes.
    void (async () => {
      const workerUrl = new URL("/sw.js", location.origin).href;
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.filter((registration) =>
        [registration.active, registration.waiting, registration.installing].some((worker) => worker?.scriptURL === workerUrl),
      ).map((registration) => registration.unregister()));
      if ("caches" in window) {
        const keys = await caches.keys();
        await Promise.all(keys.filter((key) => key.startsWith("gatiq-")).map((key) => caches.delete(key)));
      }
    })().catch(() => {});
  } else {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  }
}
